// document.addEventListener('DOMContentLoaded', function () {

//   var box = document.getElementById('cf4-options-box');
//   if (!box) return;

//   var selects = box.querySelectorAll('select[data-cf4-label]');
//   if (!selects.length) return;

//   var productsData = window.CF4_RELATED_PRODUCTS || [];
//   if (!productsData.length) return;

//   // Debug: check what data we have
//   console.log('[family-redirect] products:', productsData);

//   function getSelectedValues() {
//     var selected = {};
//     selects.forEach(function (sel) {
//       var label = sel.getAttribute('data-cf4-label');
//       selected[label] = sel.value.trim();
//     });
//     console.log('[family-redirect] selected values:', selected);
//     return selected;
//   }

//   function findMatch(selectedValues) {
//     var totalLabels = Object.keys(selectedValues).length;

//     return productsData.find(function (p) {
//       var cf4 = p.cf4 || '';
//       var segments = cf4.split('|');
//       var matched = 0;

//       segments.forEach(function (seg) {
//         seg = seg.trim();
//         if (!seg) return;

//         // Find first colon index
//         var colonIdx = seg.indexOf(':');
//         if (colonIdx === -1) return;

//         var label = seg.substring(0, colonIdx).trim();
//         // Full value including label prefix e.g. "Watt: 6 Watt = 50W"
//         var fullValue = seg.trim();

//         // Match against what dropdown value attribute has (full string)
//         if (selectedValues[label] !== undefined && selectedValues[label] === fullValue) {
//           matched++;
//         }
//       });

//       console.log('[family-redirect] product:', p.handle, 'matched:', matched, '/', totalLabels);
//       return matched === totalLabels;
//     });
//   }

//   selects.forEach(function (sel) {
//     sel.addEventListener('change', function () {
//       var selectedValues = getSelectedValues();
//       var matched = findMatch(selectedValues);
//       console.log('[family-redirect] matched product:', matched);
//       if (matched && matched.url) {
//         window.location.href = matched.url;
//       }
//     });
//   });

// });


// document.addEventListener('DOMContentLoaded', function () {

//   var box = document.getElementById('cf4-options-box');
//   if (!box) return;

//   var selects = box.querySelectorAll('select[data-cf4-label]');
//   if (!selects.length) return;

//   var productsData = window.CF4_RELATED_PRODUCTS || [];
//   if (!productsData.length) return;

//   // Build each product's label->fullSegment map
//   function buildProductMap(cf4) {
//     var map = {};
//     cf4.split('|').forEach(function (seg) {
//       seg = seg.trim();
//       if (!seg) return;
//       var colonIdx = seg.indexOf(':');
//       if (colonIdx === -1) return;
//       var label = seg.substring(0, colonIdx).trim();
//       map[label] = seg;
//     });
//     return map;
//   }

//   var productMaps = productsData.map(function (p) {
//     return { handle: p.handle, url: p.url, map: buildProductMap(p.cf4 || '') };
//   });

//   function getSelectedValues() {
//     var selected = {};
//     selects.forEach(function (sel) {
//       if (sel.value !== '__placeholder__') {
//         var label = sel.getAttribute('data-cf4-label');
//         selected[label] = sel.value.trim();
//       }
//     });
//     return selected;
//   }

//   function findMatch(selectedValues) {
//     if (Object.keys(selectedValues).length !== selects.length) return null;
//     return productMaps.find(function (p) {
//       return Object.keys(selectedValues).every(function (label) {
//         return p.map[label] === selectedValues[label];
//       });
//     });
//   }

//   // Reset dropdowns below the changed one with placeholder
//   function resetBelow(changedIndex) {
//     selects.forEach(function (sel, idx) {
//       if (idx <= changedIndex) return;
//       var label = sel.getAttribute('data-cf4-label');

//       // Remove existing placeholder if any
//       var existing = sel.querySelector('option[value="__placeholder__"]');
//       if (existing) existing.remove();

//       // Add placeholder at top
//       var placeholder = document.createElement('option');
//       placeholder.value = '__placeholder__';
//       placeholder.textContent = 'Then Select ' + label;
//       placeholder.disabled = false;
//       placeholder.selected = true;
//       sel.insertBefore(placeholder, sel.firstChild);

//       // Enable all options
//       Array.from(sel.options).forEach(function (opt) {
//         if (opt.value !== '__placeholder__') opt.disabled = false;
//       });
//     });
//   }

//   selects.forEach(function (sel, changedIndex) {
//     sel.addEventListener('change', function () {
//       if (sel.value === '__placeholder__') return;

//       // Reset all dropdowns below this one
//       resetBelow(changedIndex);

//       // Try to find full match and redirect
//       var selectedValues = getSelectedValues();
//       console.log('[family-redirect] selected:', selectedValues);

//       var matched = findMatch(selectedValues);
//       console.log('[family-redirect] matched:', matched ? matched.handle : 'none');

//       if (matched && matched.url) {
//         window.location.href = matched.url;
//       }
//     });
//   });

// });

// document.addEventListener('DOMContentLoaded', function () {

//   var box = document.getElementById('cf4-options-box');
//   if (!box) return;

//   var selects = Array.from(box.querySelectorAll('select[data-cf4-label]'));
//   if (!selects.length) return;

//   var productsData = window.CF4_RELATED_PRODUCTS || [];
//   if (!productsData.length) return;

//   console.log('[family-redirect] productsData:', productsData);

//   // Build each product label->fullSegment map
//   function buildProductMap(cf4) {
//     var map = {};
//     (cf4 || '').split('|').forEach(function (seg) {
//       seg = seg.trim();
//       if (!seg) return;
//       var colonIdx = seg.indexOf(':');
//       if (colonIdx === -1) return;
//       var label = seg.substring(0, colonIdx).trim();
//       map[label] = seg;
//     });
//     return map;
//   }

//   var productMaps = productsData.map(function (p) {
//     return { handle: p.handle, url: p.url, map: buildProductMap(p.cf4) };
//   });

//   console.log('[family-redirect] productMaps:', productMaps);

//   // Get display text by removing label prefix
//   function getDisplayText(fullSegment, label) {
//     return fullSegment.replace(label + ':', '').replace(label + ' :', '').trim();
//   }

//   // Get unique values for a label from given products
//   function getUniqueValues(candidates, label) {
//     var seen = [];
//     var result = [];
//     candidates.forEach(function (p) {
//       var fullSeg = p.map[label];
//       if (fullSeg && seen.indexOf(fullSeg) === -1) {
//         seen.push(fullSeg);
//         result.push({ full: fullSeg, display: getDisplayText(fullSeg, label) });
//       }
//     });
//     return result;
//   }

//   // Rebuild a select with given values, placeholder on top
//   function rebuildSelect(sel, values, selectedFull) {
//     var label = sel.getAttribute('data-cf4-label');
//     sel.innerHTML = '';

//     // Placeholder
//     var ph = document.createElement('option');
//     ph.value = '__placeholder__';
//     ph.textContent = 'Then Select ' + label;
//     ph.selected = !selectedFull;
//     sel.appendChild(ph);

//     values.forEach(function (val) {
//       var opt = document.createElement('option');
//       opt.value = val.full;
//       opt.textContent = val.display;
//       if (selectedFull && val.full === selectedFull) opt.selected = true;
//       sel.appendChild(opt);
//     });
//   }

//   // Get candidates filtered by selections up to given index
//   function getCandidates(upToIndex) {
//     var candidates = productMaps;
//     for (var i = 0; i <= upToIndex; i++) {
//       var val = selects[i].value;
//       if (!val || val === '__placeholder__') break;
//       var label = selects[i].getAttribute('data-cf4-label');
//       candidates = candidates.filter(function (p) {
//         return p.map[label] === val;
//       });
//     }
//     return candidates;
//   }

//   // Initialize all selects on page load
//   function init() {
//     // First select — show all unique values from all products
//     var firstLabel = selects[0].getAttribute('data-cf4-label');
//     var firstCurrentVal = selects[0].getAttribute('data-current-value');
//     var firstValues = getUniqueValues(productMaps, firstLabel);
//     rebuildSelect(selects[0], firstValues, firstCurrentVal);

//     // Rest — only show Then Select placeholder
//     for (var i = 1; i < selects.length; i++) {
//       var label = selects[i].getAttribute('data-cf4-label');
//       selects[i].innerHTML = '';
//       var ph = document.createElement('option');
//       ph.value = '__placeholder__';
//       ph.textContent = 'Then Select ' + label;
//       ph.selected = true;
//       selects[i].appendChild(ph);
//     }
//   }

//   // On change
//   function onSelectChange(changedIndex) {
//     var changedVal = selects[changedIndex].value;
//     if (changedVal === '__placeholder__') return;

//     // Get candidates after this selection
//     var candidates = getCandidates(changedIndex);

//     // Reset all selects after changed index
//     for (var i = changedIndex + 1; i < selects.length; i++) {
//       var label = selects[i].getAttribute('data-cf4-label');
//       var values = getUniqueValues(candidates, label);
//       rebuildSelect(selects[i], values, null);
//     }

//     // Check if all selected — redirect
//     var allSelected = selects.every(function (sel) {
//       return sel.value && sel.value !== '__placeholder__';
//     });

//     if (allSelected) {
//       var matched = getCandidates(selects.length - 1);
//       console.log('[family-redirect] matched:', matched);
//       if (matched.length > 0 && matched[0].url) {
//         window.location.href = matched[0].url;
//       }
//     }
//   }

//   // Init on load
//   init();

//   // Attach listeners
//   selects.forEach(function (sel, idx) {
//     sel.addEventListener('change', function () {
//       onSelectChange(idx);
//     });
//   });

// });





document.addEventListener('DOMContentLoaded', function () {

  var box = document.getElementById('cf4-options-box');
  if (!box) return;

  var selects = Array.from(box.querySelectorAll('select[data-cf4-label]'));
  if (!selects.length) return;

  var productsData = window.CF4_RELATED_PRODUCTS || [];
  if (!productsData.length) return;

  function buildProductMap(cf4) {
    var map = {};

    (cf4 || '').split('|').forEach(function (seg) {
      seg = seg.trim();
      if (!seg) return;

      var colonIdx = seg.indexOf(':');
      if (colonIdx === -1) return;

      var label = seg.substring(0, colonIdx).trim();
      map[label] = seg;
    });

    return map;
  }

  var productMaps = productsData.map(function (p) {
    return {
      handle: p.handle,
      url: p.url,
      map: buildProductMap(p.cf4)
    };
  });

  function getDisplayText(fullSegment, label) {
    return fullSegment
      .replace(label + ':', '')
      .replace(label + ' :', '')
      .trim();
  }

  function getUniqueValues(candidates, label) {
    var seen = [];
    var result = [];

    candidates.forEach(function (p) {
      var fullSeg = p.map[label];

      if (fullSeg && seen.indexOf(fullSeg) === -1) {
        seen.push(fullSeg);

        result.push({
          full: fullSeg,
          display: getDisplayText(fullSeg, label)
        });
      }
    });

    return result;
  }

  function getCandidates(upToIndex) {
    var candidates = productMaps;

    for (var i = 0; i <= upToIndex; i++) {

      var val = selects[i].value;

      if (!val || val === '__placeholder__') break;

      var label = selects[i].getAttribute('data-cf4-label');

      candidates = candidates.filter(function (p) {
        return p.map[label] === val;
      });
    }

    return candidates;
  }

 
function init() {

  selects.forEach(function (sel, idx) {

    var label = sel.getAttribute('data-cf4-label');
    var currentVal = sel.getAttribute('data-current-value');

    var candidates = idx === 0
      ? productMaps
      : getCandidates(idx - 1);

    var values = getUniqueValues(candidates, label);

    sel.innerHTML = '';

    // Add all values
    values.forEach(function (val) {

      var opt = document.createElement('option');
      opt.value = val.full;
      opt.textContent = val.display;

      // Keep current product selected initially
      if (currentVal && val.full === currentVal) {
        opt.selected = true;
      }

      sel.appendChild(opt);
    });

  });

}
  // Reset below selects
  function resetBelow(changedIndex, candidates) {

    for (var i = changedIndex + 1; i < selects.length; i++) {

      var label = selects[i].getAttribute('data-cf4-label');

      var values = getUniqueValues(candidates, label);

      selects[i].innerHTML = '';

      // If no values available
      if (!values.length) continue;

      // Add placeholder
      var ph = document.createElement('option');
      ph.value = '__placeholder__';
      ph.textContent = 'Then Select ' + label;
      ph.selected = true;

      selects[i].appendChild(ph);

      // Add options
      values.forEach(function (val) {

        var opt = document.createElement('option');
        opt.value = val.full;
        opt.textContent = val.display;

        selects[i].appendChild(opt);
      });

      // IMPORTANT:
      // Only populate NEXT select
      break;
    }
  }

  // Redirect only when no more values exist below
  function tryRedirect(candidates, changedIndex) {

    if (candidates.length !== 1) return;

    // Check remaining selects
    for (var i = changedIndex + 1; i < selects.length; i++) {

      var label = selects[i].getAttribute('data-cf4-label');

      var values = getUniqueValues(candidates, label);

      // If any next dropdown still has values,
      // don't redirect yet
      if (values.length > 0) {
        return;
      }
    }

    // Redirect only when NO further values exist
    console.log('[family-redirect] redirecting:', candidates[0].handle);

    window.location.href = candidates[0].url;
  }

  init();

  selects.forEach(function (sel, idx) {

    sel.addEventListener('change', function () {

      if (sel.value === '__placeholder__') return;

      var candidates = getCandidates(idx);

      // Clear all below selects first
      for (var j = idx + 1; j < selects.length; j++) {
        var label = selects[j].getAttribute('data-cf4-label');

        selects[j].innerHTML = '';

        var ph = document.createElement('option');
        ph.value = '__placeholder__';
        ph.textContent = 'Then Select ' + label;
        ph.selected = true;

        selects[j].appendChild(ph);
      }

      // Populate only next select
      resetBelow(idx, candidates);

      // Redirect only if no more dropdown values exist
      tryRedirect(candidates, idx);
    });

  });

});

